import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import Missing from '../views/404.vue'
import Demo from '../views/Demo.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'MinimalPortfolio',
        meta: {
            title: 'RAD Software - Home'
        },
        component: () =>
            import ('../views/all-home-version/MinimalPortfolio.vue')
    },
    {
        path: '/about',
        name: 'About',
        meta: {
            title: 'About - RAD Software'
        },
        component: () =>
            import ('../views/About.vue')
    },
    {
        path: '/service',
        name: 'Service',
        meta: {
            title: 'Service - RAD Software'
        },
        component: () =>
            import ('../views/service/Service.vue')
    },
    /* {
        path: '/portfolio',
        name: 'Portfolio',
        meta: {
            title: 'Portfolio - RAD Software'
        },
        component: () =>
            import ('../views/portfolio/Portfolio.vue')
    }, */
    {
        path: '/portfolio/pms-demo',
        name: 'PmsDemo',
        meta: {
            title: 'Project Management System - RAD Software'
        },
        component: () =>
            import ('../views/portfolio/pms-demo.vue')
    },
    {
        path: '/portfolio/inventory-with-pos',
        name: 'InventoryWithPos',
        meta: {
            title: 'Inventory With POS - RAD Software'
        },
        component: () =>
            import ('../views/portfolio/inventory-with-pos.vue')
    },
    {
        path: '/portfolio/xfsdph',
        name: 'Xfsdph',
        meta: {
            title: 'XFSDPH - Account Management System'
        },
        component: () =>
            import ('../views/portfolio/xfsdph.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        meta: {
            title: 'Contact - RAD Software'
        },
        component: () =>
            import ('../views/Contact.vue')
    },
    {
        path: '/404',
        name: '404',
        meta: {
            title: '404 - RAD Software'
        },
        component: () =>
            import ('../views/404.vue')
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})


export default router